// terminal fiyati default fiyati
// ayni slot no yok bir kurustan kucuk deger yok terminal fiayti listede farkli ise uyari

import { useState, useEffect, useMemo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import CircularProgress from "@mui/material/CircularProgress";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import SendToMobileIcon from "@mui/icons-material/SendToMobile";
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import { DataGrid } from "@mui/x-data-grid";
import SlotDragDropDialog from "./SlotDragDropDialog";
import { useTranslation } from "react-i18next";
import { getSlots, postSlots, putSlots, deleteSlots } from "../../api/slotsAPI";
import { getSlotsDefinitions } from "../../api/slotsDefinitionsAPI";
import { getStockCards } from "../../api/stockCardsAPI";
import { getNode } from "../../api/nodeAPI";
import { getDevices } from "../../api/deviceAPI";
import {
  getNodeSlotDefinition,
  postNodeSlotDefinition,
  putNodeSlotDefinition,
} from "../../api/nodeSlotDefinitionAPI";
import { postCommand, getCommandResponse } from "../../api/commandAPI";

export default function SlotGrid({ selectedConfig, refreshTrigger }) {
  const { t } = useTranslation();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [allRows, setAllRows] = useState([]);

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const open = Boolean(anchorEl);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({
    idslotTable: "",
    slotNo: "",
    itemCount: "",
    priceOverride: false,
    terminalPrice: "",
    slotPrice: "0",
    slotDefinitionTable_idslotDefinitionTable: "",
    stockTable_idStockTable: "",
  });

  const [slotDefinitions, setSlotDefinitions] = useState([]);
  const [stockCards, setStockCards] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [formErrors, setFormErrors] = useState({
    stockTable_idStockTable: "",
    slotNo: "",
    itemCount: "",
    slotPrice: "",
    slotDefinitionTable_idslotDefinitionTable: "",
  });
  const [deleteConfirmDialog, setDeleteConfirmDialog] = useState({
    open: false,
    type: null, // 'selected' or 'all'
  });

  // Otomatlara Yükle dialog states
  const [loadToMachinesDialogOpen, setLoadToMachinesDialogOpen] = useState(false);
  const [allNodes, setAllNodes] = useState([]);
  const [nodeSlotDefinitions, setNodeSlotDefinitions] = useState([]);
  const [selectedMachineIds, setSelectedMachineIds] = useState([]);
  const [loadToMachinesLoading, setLoadToMachinesLoading] = useState(false);
  const [dragDropDialogOpen, setDragDropDialogOpen] = useState(false);

  const handleMenuClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleEdit = async () => {
    try {
      const [definitions, stocks] = await Promise.all([
        getSlotsDefinitions(),
        getStockCards(),
      ]);
      setSlotDefinitions(definitions);
      setStockCards(stocks);

      // Seçili stok'un fiyatını bul
      const selectedStock = stocks.find((stock) => stock.idstockTable === selectedRow.stockId);
      const terminalPrice = selectedStock ? selectedStock.stockPrice : "";

      setFormData({
        idslotTable: selectedRow.id,
        slotNo: selectedRow.slotNo,
        itemCount: selectedRow.itemCount,
        priceOverride: selectedRow.priceOverride === 1,
        terminalPrice: terminalPrice,
        slotPrice: selectedRow.slotPrice,
        slotDefinitionTable_idslotDefinitionTable: selectedRow.slotDefinitionId,
        stockTable_idStockTable: selectedRow.stockId,
      });

      setIsEditMode(true);
      setDialogOpen(true);
      handleMenuClose();
    } catch (error) {
      console.error("Error loading edit data:", error);
      alert(t('stocks.slotGrid.loadDataError', { error: error.message }));
    }
  };

  const handleDelete = async () => {
    if (!selectedRow) return;

    const confirmDelete = window.confirm(
      `"${selectedRow.stockName}" ürününü Slot ${selectedRow.slotNo}'dan silmek istediğinizden emin misiniz?`
    );

    if (!confirmDelete) {
      handleMenuClose();
      return;
    }

    try {
      setLoading(true);
      await deleteSlots(selectedRow.id);

      handleMenuClose();

      // Listeyi yeniden yükle
      const data = await getSlots();
      const formattedRows = data.map((item) => ({
        id: item.idslotTable,
        slotNo: item.slotNo,
        itemCount: item.itemCount,
        priceOverride: item.priceOverride,
        slotPrice: item.slotPrice,
        stockName: item.stockTable_name,
        slotDefinitionName: item.slotDefinitionTable_name,
        slotDefinitionId: item.slotDefinitionTable_idslotDefinitionTable,
        stockId: item.stockTable_idStockTable,
      }));
      setAllRows(formattedRows);
      setRows(formattedRows);

      setSnackbar({
        open: true,
        message: t("stocks.slotGrid.deleteSuccess"),
        severity: "success",
      });
    } catch (error) {
      console.error("Error deleting slot:", error);
      setSnackbar({
        open: true,
        message: t("stocks.slotGrid.deleteError") + ": " + error.message,
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleOpenDeleteConfirm = (type) => {
    setDeleteConfirmDialog({ open: true, type });
  };

  const handleCloseDeleteConfirm = () => {
    setDeleteConfirmDialog({ open: false, type: null });
  };

  const handleConfirmDelete = async () => {
    const type = deleteConfirmDialog.type;
    handleCloseDeleteConfirm();

    if (type === 'selected') {
      await executeDeleteSelected();
    } else if (type === 'all') {
      await executeDeleteAll();
    }
  };

  const executeDeleteSelected = async () => {
    if (selectedRows.length === 0) return;

    try {
      setLoading(true);
      const deleteCount = selectedRows.length;

      // Seçili slotları tek tek sil
      for (const id of selectedRows) {
        await deleteSlots(id);
      }

      // Seçimi temizle
      setSelectedRows([]);

      // Listeyi yeniden yükle
      const data = await getSlots();
      const formattedRows = data.map((item) => ({
        id: item.idslotTable,
        slotNo: item.slotNo,
        itemCount: item.itemCount,
        priceOverride: item.priceOverride,
        slotPrice: item.slotPrice,
        stockName: item.stockTable_name,
        slotDefinitionName: item.slotDefinitionTable_name,
        slotDefinitionId: item.slotDefinitionTable_idslotDefinitionTable,
        stockId: item.stockTable_idStockTable,
      }));
      setAllRows(formattedRows);
      setRows(formattedRows);

      setSnackbar({
        open: true,
        message: `${deleteCount} slot başarıyla silindi.`,
        severity: "success",
      });
    } catch (error) {
      console.error("Error deleting selected slots:", error);
      setSnackbar({
        open: true,
        message: t("stocks.slotGrid.deleteError") + ": " + error.message,
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const executeDeleteAll = async () => {
    if (!selectedConfig || rows.length === 0) return;

    try {
      setLoading(true);
      const deleteCount = rows.length;

      // Tüm slotları tek tek sil
      for (const row of rows) {
        await deleteSlots(row.id);
      }

      // Seçimi temizle
      setSelectedRows([]);

      // Listeyi yeniden yükle
      const data = await getSlots();
      const formattedRows = data.map((item) => ({
        id: item.idslotTable,
        slotNo: item.slotNo,
        itemCount: item.itemCount,
        priceOverride: item.priceOverride,
        slotPrice: item.slotPrice,
        stockName: item.stockTable_name,
        slotDefinitionName: item.slotDefinitionTable_name,
        slotDefinitionId: item.slotDefinitionTable_idslotDefinitionTable,
        stockId: item.stockTable_idStockTable,
      }));
      setAllRows(formattedRows);
      setRows(formattedRows);

      setSnackbar({
        open: true,
        message: `${deleteCount} slot başarıyla silindi.`,
        severity: "success",
      });
    } catch (error) {
      console.error("Error deleting all slots:", error);
      setSnackbar({
        open: true,
        message: t("stocks.slotGrid.deleteError") + ": " + error.message,
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDragDropSaved = async () => {
    try {
      setLoading(true);
      const data = await getSlots();
      const formattedRows = data.map((item) => ({
        id: item.idslotTable,
        slotNo: item.slotNo,
        itemCount: item.itemCount,
        priceOverride: item.priceOverride,
        slotPrice: item.slotPrice,
        stockName: item.stockTable_name,
        slotDefinitionName: item.slotDefinitionTable_name,
        slotDefinitionId: item.slotDefinitionTable_idslotDefinitionTable,
        stockId: item.stockTable_idStockTable,
      }));
      setAllRows(formattedRows);
    } catch (error) {
      console.error("Error reloading slots after drag-drop save:", error);
    } finally {
      setLoading(false);
    }
  };

  // Otomatlara Yükle handlers
  const handleOpenLoadToMachinesDialog = async () => {
    if (!selectedConfig) return;

    try {
      setLoadToMachinesLoading(true);

      // Tüm node'ları ve mevcut nodeSlotDefinition'ları getir
      const [nodes, nodeSlotsData] = await Promise.all([
        getNode(),
        getNodeSlotDefinition(),
      ]);

      setAllNodes(nodes || []);
      setNodeSlotDefinitions(nodeSlotsData || []);

      // Bu slot tanımının atandığı otomatları önceden seç
      const preSelectedIds = (nodeSlotsData || [])
        .filter((nsd) => nsd.slotDefinitionTable_idslotDefinitionTable === selectedConfig.id)
        .map((nsd) => nsd.nodeId || nsd.node_idNode);

      setSelectedMachineIds(preSelectedIds);
      setLoadToMachinesDialogOpen(true);
    } catch (error) {
      console.error("Error loading machines:", error);
      setSnackbar({
        open: true,
        message: t("stocks.slotGrid.loadMachinesError") || "Otomatlar yüklenirken hata oluştu",
        severity: "error",
      });
    } finally {
      setLoadToMachinesLoading(false);
    }
  };

  const handleCloseLoadToMachinesDialog = () => {
    setLoadToMachinesDialogOpen(false);
    setSelectedMachineIds([]);
  };

  // getConfig komutu gönderip yanıt bekle
  const sendGetConfigCommand = async (node) => {
    const cmdKey = crypto.randomUUID();
    const maxRetries = 3; // 2 saniye timeout
    const retryInterval = 1000; // 1 saniye

    try {
      // Komutu gönder
      await postCommand(node.idNode, node.deviceId, cmdKey, "getConfig", []);
      console.log("Command sent with cmdKey:", cmdKey);

      // Yanıt gelene kadar bekle
      for (let i = 0; i < maxRetries; i++) {
        await new Promise((resolve) => setTimeout(resolve, retryInterval));

        try {
          const response = await getCommandResponse(node.idNode, node.deviceId, cmdKey);
          console.log(`Attempt ${i + 1}/${maxRetries} - Response:`, response);

          // Response array ve dolu ise yanıt gelmiş demektir
          if (response && Array.isArray(response) && response.length > 0) {
            console.log("Response received! Stopping polling for node:", node.idNode);
            return { success: true, nodeId: node.idNode };
          }
        } catch {
          // Yanıt henüz gelmedi, devam et
        }
      }

      // Timeout - cihaz yanıt vermedi
      console.log("Timeout for node:", node.idNode);
      return { success: false, nodeId: node.idNode, error: "timeout" };
    } catch (error) {
      return { success: false, nodeId: node.idNode, error: error.message };
    }
  };

  const handleLoadToMachines = async () => {
    if (!selectedConfig || selectedMachineIds.length === 0) return;

    try {
      setLoadToMachinesLoading(true);
      let successCount = 0;
      let errorCount = 0;

      // Tüm device'ları al (nodeId - deviceId eşleştirmesi için)
      const allDevices = await getDevices();
      const devicesData = Array.isArray(allDevices) ? allDevices : allDevices.data || [];

      for (const nodeId of selectedMachineIds) {
        // Bu node'un mevcut slot tanımı var mı kontrol et
        const existingDef = nodeSlotDefinitions.find(
          (nsd) => Number(nsd.nodeId || nsd.node_idNode) === Number(nodeId)
        );

        try {
          if (existingDef) {
            // Varsa güncelle (PUT)
            await putNodeSlotDefinition(
              existingDef.idnodeSlotDefinition,
              nodeId,
              selectedConfig.id
            );
          } else {
            // Yoksa yeni ekle (POST)
            await postNodeSlotDefinition(nodeId, selectedConfig.id);
          }
          successCount++;
        } catch (error) {
          console.error(`Error loading to node ${nodeId}:`, error);
          errorCount++;
        }
      }

      // Her otomata sırayla getConfig komutu gönder ve yanıt bekle
      let commandSuccessCount = 0;
      let commandErrorCount = 0;

      for (const nodeId of selectedMachineIds) {
        const node = allNodes.find((n) => n.idNode === nodeId);
        // Bu node'a ait device'ı bul
        const device = devicesData.find((d) => d.node_idNode === nodeId);

        if (node && device && device.idDevice) {
          const result = await sendGetConfigCommand({ idNode: nodeId, deviceId: device.idDevice });
          if (result.success) {
            commandSuccessCount++;
          } else {
            commandErrorCount++;
          }
        } else {
          commandErrorCount++;
        }
      }

      handleCloseLoadToMachinesDialog();

      if (errorCount > 0 || commandErrorCount > 0) {
        setSnackbar({
          open: true,
          message: t("stocks.slotGrid.loadToMachinesPartialSuccess", { success: successCount, error: errorCount }) ||
            `${successCount} otomata yüklendi, ${commandSuccessCount} otomata komut gönderildi.`,
          severity: "warning",
        });
      } else {
        setSnackbar({
          open: true,
          message: t("stocks.slotGrid.loadToMachinesSuccess", { count: successCount }) ||
            `${successCount} otomata başarıyla yüklendi ve komut gönderildi.`,
          severity: "success",
        });
      }
    } catch (error) {
      console.error("Error loading to machines:", error);
      setSnackbar({
        open: true,
        message: t("stocks.slotGrid.loadToMachinesError") || "Yükleme sırasında hata oluştu",
        severity: "error",
      });
    } finally {
      setLoadToMachinesLoading(false);
    }
  };

  // Otomat listesi için satırlar
  const machineRows = useMemo(() => {
    return allNodes.map((node) => {
      const existingDef = nodeSlotDefinitions.find(
        (nsd) => Number(nsd.nodeId || nsd.node_idNode) === Number(node.idNode)
      );

      return {
        id: node.idNode,
        idNode: node.idNode,
        code: node.code,
        name: node.name,
        city: node.city || "-",
        town: node.town || "-",
        currentSlotDefinition: existingDef?.slotDefinitionTable_name || "-",
      };
    });
  }, [allNodes, nodeSlotDefinitions]);

  // Otomat listesi için kolonlar
  const machineColumns = useMemo(() => [
    {
      field: "code",
      headerName: t("places.dataGrid.code") || "Yer Kodu",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "city",
      headerName: t("places.dataGrid.city") || "Şehir",
      flex: 0.8,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "town",
      headerName: t("places.dataGrid.town") || "İlçe",
      flex: 0.8,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "currentSlotDefinition",
      headerName: t("stocks.slotGrid.currentSlotDefinition") || "Mevcut Slot Tanımı",
      flex: 1.2,
      headerAlign: "center",
      align: "center",
    },
  ], [t]);

  const handleOpenDialog = async () => {
    try {
      const [definitions, stocks] = await Promise.all([
        getSlotsDefinitions(),
        getStockCards(),
      ]);
      setSlotDefinitions(definitions);
      setStockCards(stocks);
      setIsEditMode(false);

      // Eğer selectedConfig varsa, slot tanımını otomatik seç
      if (selectedConfig) {
        setFormData((prev) => ({
          ...prev,
          slotDefinitionTable_idslotDefinitionTable: selectedConfig.id,
        }));
      }

      setDialogOpen(true);
    } catch (error) {
      console.error("Error loading dropdown data:", error);
      alert(t('stocks.slotGrid.loadDataError', { error: error.message }));
    }
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setIsEditMode(false);
    setFormData({
      idslotTable: "",
      slotNo: "",
      itemCount: "",
      priceOverride: false,
      terminalPrice: "",
      slotPrice: "0",
      slotDefinitionTable_idslotDefinitionTable: "",
      stockTable_idStockTable: "",
    });
    setFormErrors({
      stockTable_idStockTable: "",
      slotNo: "",
      itemCount: "",
      slotPrice: "",
      slotDefinitionTable_idslotDefinitionTable: "",
    });
  };

  const handleFormChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleStockChange = (stockId) => {
    const selectedStock = stockCards.find((stock) => stock.idstockTable === stockId);
    setFormData((prev) => ({
      ...prev,
      stockTable_idStockTable: stockId,
      terminalPrice: selectedStock ? selectedStock.stockPrice : "",
      // Eğer "Otomat Fiyatı" seçiliyse (priceOverride === false), slotPrice'ı 0 yap
      // Eğer "Ürün Fiyatı" seçiliyse (priceOverride === true), slotPrice değişmez
      slotPrice: prev.priceOverride ? prev.slotPrice : "0",
    }));
  };

  const validateForm = () => {
    const errors = {
      stockTable_idStockTable: "",
      slotNo: "",
      itemCount: "",
      slotPrice: "",
      slotDefinitionTable_idslotDefinitionTable: "",
    };
    let isValid = true;

    const slotNoToCheck = parseInt(formData.slotNo);
    const itemCountToCheck = parseInt(formData.itemCount);
    const slotPriceToCheck = parseInt(formData.slotPrice);
    const slotDefinitionId = parseInt(formData.slotDefinitionTable_idslotDefinitionTable);

    // Ürün seçimi zorunlu
    if (!formData.stockTable_idStockTable) {
      errors.stockTable_idStockTable = t("validation.required", "Bu alan zorunludur");
      isValid = false;
    }

    // Slot No negatif olamaz
    if (isNaN(slotNoToCheck) || slotNoToCheck < 0) {
      errors.slotNo = "Slot No negatif olamaz";
      isValid = false;
    }

    // Ürün Adedi negatif olamaz
    if (isNaN(itemCountToCheck) || itemCountToCheck < 0) {
      errors.itemCount = "Ürün Adedi negatif olamaz";
      isValid = false;
    }

    // Ürün Fiyatı seçiliyse (priceOverride === true), Stok Fiyatı 0'dan büyük olmalı
    if (formData.priceOverride && (isNaN(slotPriceToCheck) || slotPriceToCheck <= 0)) {
      errors.slotPrice = "Stok Fiyatı 0'dan büyük olmalıdır";
      isValid = false;
    }

    // Slot tanımı seçimi zorunlu (selectedConfig yoksa)
    if (!selectedConfig && !slotDefinitionId) {
      errors.slotDefinitionTable_idslotDefinitionTable = t("validation.required", "Bu alan zorunludur");
      isValid = false;
    }

    // Aynı slot numarası kontrolü
    if (isValid && !isNaN(slotNoToCheck)) {
      if (!isEditMode) {
        const existingSlot = allRows.find(
          (row) => row.slotNo === slotNoToCheck && row.slotDefinitionId === slotDefinitionId
        );
        if (existingSlot) {
          errors.slotNo = `Slot No ${slotNoToCheck} zaten kullanımda! Bu slotta "${existingSlot.stockName}" bulunuyor.`;
          isValid = false;
        }
      } else {
        const existingSlot = allRows.find(
          (row) =>
            row.slotNo === slotNoToCheck &&
            row.slotDefinitionId === slotDefinitionId &&
            row.id !== parseInt(formData.idslotTable)
        );
        if (existingSlot) {
          errors.slotNo = `Slot No ${slotNoToCheck} zaten kullanımda! Bu slotta "${existingSlot.stockName}" bulunuyor.`;
          isValid = false;
        }
      }
    }

    setFormErrors(errors);
    return isValid;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }

    try {
      setLoading(true);

      const slotNoToCheck = parseInt(formData.slotNo);
      const itemCountToCheck = parseInt(formData.itemCount);
      const slotPriceToCheck = parseInt(formData.slotPrice);
      const slotDefinitionId = parseInt(formData.slotDefinitionTable_idslotDefinitionTable);

      const dataToSubmit = {
        slotNo: slotNoToCheck,
        itemCount: itemCountToCheck,
        priceOverride: formData.priceOverride ? 1 : 0,
        slotPrice: slotPriceToCheck,
        slotDefinitionTable_idslotDefinitionTable: slotDefinitionId,
        stockTable_idStockTable: parseInt(formData.stockTable_idStockTable),
      };

      if (isEditMode) {
        // Edit mode: idslotTable'ı da ekle
        dataToSubmit.idslotTable = parseInt(formData.idslotTable);
        await putSlots(dataToSubmit);
      } else {
        // Add mode
        await postSlots(dataToSubmit);
      }

      handleCloseDialog();

      // Listeyi yeniden yükle
      const data = await getSlots();
      const formattedRows = data.map((item) => ({
        id: item.idslotTable,
        slotNo: item.slotNo,
        itemCount: item.itemCount,
        priceOverride: item.priceOverride,
        slotPrice: item.slotPrice,
        stockName: item.stockTable_name,
        slotDefinitionName: item.slotDefinitionTable_name,
        slotDefinitionId: item.slotDefinitionTable_idslotDefinitionTable,
        stockId: item.stockTable_idStockTable,
      }));
      setAllRows(formattedRows);
      setRows(formattedRows);
    } catch (error) {
      console.error(`Error ${isEditMode ? 'updating' : 'creating'} slot:`, error);
      alert(`Slot ${isEditMode ? 'güncellenirken' : 'eklenirken'} hata oluştu: ` + error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchSlots = async () => {
      try {
        setLoading(true);
        const data = await getSlots();

        // API'den gelen veriyi DataGrid formatına dönüştür
        const formattedRows = data.map((item) => ({
          id: item.idslotTable,
          slotNo: item.slotNo,
          itemCount: item.itemCount,
          priceOverride: item.priceOverride,
          slotPrice: item.slotPrice,
          stockName: item.stockTable_name,
          slotDefinitionName: item.slotDefinitionTable_name,
          slotDefinitionId: item.slotDefinitionTable_idslotDefinitionTable,
          stockId: item.stockTable_idStockTable,
        }));

        setAllRows(formattedRows);
        setRows(formattedRows);
      } catch (error) {
        console.error("Error fetching slots:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSlots();
  }, [refreshTrigger]);

  // Seçilen config'e göre filtreleme
  useEffect(() => {
    if (selectedConfig) {
      const filtered = allRows.filter(
        (row) => row.slotDefinitionId === selectedConfig.id
      );
      setRows(filtered);
    } else {
      setRows(allRows);
    }
  }, [selectedConfig, allRows]);

  const columns = [
    {
      field: "actions",
      headerName: "",
      width: 70,
      flex: 0.3,
      align: "center",
      headerAlign: "center",
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <IconButton
            size="small"
            onClick={(event) => {
              event.stopPropagation();
              handleMenuClick(event, params.row);
            }}
          >
            <MoreHorizIcon />
          </IconButton>
        );
      },
    },
    {
      field: "stockName",
      headerName: t("stocks.slotGrid.stockName"),
      width: 150,
      flex: 1.2,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "slotPrice",
      headerName: t("stocks.slotGrid.slotPrice"),
      width: 120,
      flex: 1,
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (value) => {
        if (value == null) return "";
        // Kuruştan liraya çevir (100'e böl)
        return `${(value / 100).toFixed(2)} ₺`;
      },
    },
    {
      field: "slotNo",
      headerName: t("stocks.slotGrid.slotNo"),
      width: 100,
      flex: 0.7,
      headerAlign: "center",
      align: "center",
      type: "number",
    },
    {
      field: "itemCount",
      headerName: t("stocks.slotGrid.itemCount"),
      width: 120,
      flex: 0.8,
      headerAlign: "center",
      align: "center",
      type: "number",
    },
    {
      field: "priceOverride",
      headerName: t("stocks.slotGrid.priceOverride"),
      width: 130,
      flex: 1,
      headerAlign: "center",
      align: "center",
      type: "boolean",
    },
    
    
  ];

  return (
    <Box sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
      {!selectedConfig ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            flex: 1,
            minHeight: 600,
            gap: 3,
            px: 6,
            py: 4,
            backgroundColor: "background.paper",
            borderRadius: 1,
          }}
        >
          <Box
            sx={{
              width: 120,
              height: 120,
              borderRadius: "50%",
              backgroundColor: "primary.light",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              animation: "pulse 2s ease-in-out infinite",
              "@keyframes pulse": {
                "0%, 100%": {
                  opacity: 0.6,
                  transform: "scale(1)",
                },
                "50%": {
                  opacity: 1,
                  transform: "scale(1.05)",
                },
              },
            }}
          >
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: "50%",
                backgroundColor: "primary.main",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  color: "primary.contrastText",
                  fontWeight: 300,
                }}
              >
                ←
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              textAlign: "center",
              maxWidth: 400,
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: 600,
                mb: 1,
                color: "text.primary",
              }}
            >
              {t("stocks.slotGrid.selectConfigTitle")}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "text.secondary",
                lineHeight: 1.6,
              }}
            >
              {t("stocks.slotGrid.selectConfigDescription")}
            </Typography>
          </Box>
        </Box>
      ) : (
        <>
          <Stack direction="row" spacing={2} sx={{ mb: 2, ml: 2, alignItems: "center" }}>
            <Typography variant="h5" sx={{ fontWeight: "bold" }}>
              {selectedConfig.name}
            </Typography>
            <Box sx={{ flex: 1 }} />
            {rows.length > 0 && (
              <Button
                variant="outlined"
                color="error"
                startIcon={<DeleteSweepIcon />}
                onClick={() => handleOpenDeleteConfirm(selectedRows.length > 0 ? 'selected' : 'all')}
              >
                {selectedRows.length > 0
                  ? `${t("common.deleteSelected")} (${selectedRows.length})`
                  : t("common.deleteAll")}
              </Button>
            )}
            <Button
              variant="outlined"
              color="primary"
              startIcon={<SendToMobileIcon />}
              onClick={handleOpenLoadToMachinesDialog}
            >
              {t("stocks.slotGrid.loadToMachines")}
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              startIcon={<DashboardCustomizeIcon />}
              onClick={() => setDragDropDialogOpen(true)}
            >
              Hızlı Düzen
            </Button>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={handleOpenDialog}
            >
              {t("common.add")}
            </Button>
          </Stack>
          <Box sx={{ flex: 1, minHeight: 600 }}>
            <DataGrid
              rows={rows}
              columns={columns}
              loading={loading}
              checkboxSelection
              rowSelectionModel={selectedRows}
              onRowSelectionModelChange={(newSelection) => setSelectedRows(newSelection)}
              initialState={{
                pagination: {
                  paginationModel: { pageSize: 25 },
                },
              }}
              pageSizeOptions={[25, 50, 100]}
              disableRowSelectionOnClick
              sx={{
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontWeight: "bold",
                },
              }}
            />
          </Box>
        </>
      )}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem onClick={handleEdit}>
          <EditIcon sx={{ mr: 1, fontSize: 20 }} />
          {t("common.edit")}
        </MenuItem>
        <MenuItem onClick={handleDelete} sx={{ color: "error.main" }}>
          <DeleteIcon sx={{ mr: 1, fontSize: 20 }} />
          {t("common.delete")}
        </MenuItem>
      </Menu>

      <Dialog open={dialogOpen} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
        <DialogTitle>
          {isEditMode ? t("stocks.slotGrid.editSlot") : t("stocks.slotGrid.addSlot")}
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 2 }}>
            {/* 1. Ürün Adı (Stock Name) */}
            <FormControl fullWidth required error={Boolean(formErrors.stockTable_idStockTable)}>
              <InputLabel>{t("stocks.slotGrid.productName")}</InputLabel>
              <Select
                value={formData.stockTable_idStockTable}
                label={t("stocks.slotGrid.productName")}
                onChange={(e) => handleStockChange(e.target.value)}
              >
                {stockCards.map((stock) => (
                  <MenuItem key={stock.idstockTable} value={stock.idstockTable}>
                    {stock.stockName}
                  </MenuItem>
                ))}
              </Select>
              {formErrors.stockTable_idStockTable && (
                <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.5 }}>
                  {formErrors.stockTable_idStockTable}
                </Typography>
              )}
            </FormControl>

            {/* 2. Slot No */}
            <TextField
              label={t("stocks.slotGrid.slotNo")}
              type="number"
              fullWidth
              required
              value={formData.slotNo}
              onChange={(e) => handleFormChange("slotNo", e.target.value)}
              error={Boolean(formErrors.slotNo)}
              helperText={formErrors.slotNo}
            />

            {/* 3. Ürün Adedi */}
            <TextField
              label={t("stocks.slotGrid.itemCount")}
              type="number"
              fullWidth
              required
              value={formData.itemCount}
              onChange={(e) => handleFormChange("itemCount", e.target.value)}
              error={Boolean(formErrors.itemCount)}
              helperText={formErrors.itemCount}
            />

            {/* 4. Fiyat Seçimi - Radio Buttons */}
            <FormControl component="fieldset">
              <RadioGroup
                value={formData.priceOverride ? "product" : "terminal"}
                onChange={(e) => {
                  const isProduct = e.target.value === "product";
                  setFormData((prev) => ({
                    ...prev,
                    priceOverride: isProduct,
                    // Otomat Fiyatı seçilirse, slot fiyatını 0 yap
                    slotPrice: isProduct ? prev.slotPrice : "0",
                  }));
                }}
              >
                <FormControlLabel
                  value="terminal"
                  control={<Radio />}
                  label="Otomat Fiyatı"
                />
                <FormControlLabel
                  value="product"
                  control={<Radio />}
                  label={
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1, width: "100%" }}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Typography>Ürün Fiyatı</Typography>
                        <Typography sx={{ fontWeight: "bold", color: "primary.main" }}>
                          {formData.terminalPrice ? `${(formData.terminalPrice / 100).toFixed(2)} ₺` : "-"}
                        </Typography>
                      </Box>
                      {formData.priceOverride && (
                        <TextField
                          label="Stok Fiyatı (Kuruş)"
                          type="number"
                          size="small"
                          fullWidth
                          value={formData.slotPrice}
                          onChange={(e) => handleFormChange("slotPrice", e.target.value)}
                          onClick={(e) => e.stopPropagation()}
                          inputProps={{ step: "1", min: "0" }}
                          error={Boolean(formErrors.slotPrice)}
                          helperText={
                            formErrors.slotPrice || (formData.slotPrice > 0
                              ? `Lira: ${(formData.slotPrice / 100).toFixed(2)} ₺`
                              : "")
                          }
                        />
                      )}
                    </Box>
                  }
                />
              </RadioGroup>
            </FormControl>

            {/* 7. Slot Tanımı (sadece selectedConfig yoksa göster) */}
            {!selectedConfig && (
              <FormControl fullWidth required error={Boolean(formErrors.slotDefinitionTable_idslotDefinitionTable)}>
                <InputLabel>{t("stocks.slotGrid.slotDefinition")}</InputLabel>
                <Select
                  value={formData.slotDefinitionTable_idslotDefinitionTable}
                  label={t("stocks.slotGrid.slotDefinition")}
                  onChange={(e) =>
                    handleFormChange("slotDefinitionTable_idslotDefinitionTable", e.target.value)
                  }
                >
                  {slotDefinitions.map((definition) => (
                    <MenuItem key={definition.idslotDefinitionTable} value={definition.idslotDefinitionTable}>
                      {definition.name}
                    </MenuItem>
                  ))}
                </Select>
                {formErrors.slotDefinitionTable_idslotDefinitionTable && (
                  <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.5 }}>
                    {formErrors.slotDefinitionTable_idslotDefinitionTable}
                  </Typography>
                )}
              </FormControl>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>{t("common.cancel")}</Button>
          <Button onClick={handleSubmit} variant="contained" color="primary">
            {t("common.save")}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteConfirmDialog.open}
        onClose={handleCloseDeleteConfirm}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          {t("common.confirmDelete")}
        </DialogTitle>
        <DialogContent>
          <Typography>
            {deleteConfirmDialog.type === 'selected'
              ? t("common.confirmDeleteSelected", { count: selectedRows.length })
              : t("common.confirmDeleteAll", { count: rows.length })}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteConfirm}>
            {t("common.cancel")}
          </Button>
          <Button onClick={handleConfirmDelete} variant="contained" color="error">
            {t("common.delete")}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Otomatlara Yükle Dialog */}
      <Dialog
        open={loadToMachinesDialogOpen}
        onClose={handleCloseLoadToMachinesDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          {t("stocks.slotGrid.loadToMachines")} - {selectedConfig?.name}
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 2 }}>
            <Typography variant="body2" color="text.secondary">
              {t("stocks.slotGrid.loadToMachinesDescription")}
            </Typography>

            {machineRows.length === 0 ? (
              <Box sx={{ p: 3, textAlign: "center" }}>
                <Typography color="text.secondary">
                  {t("stocks.slotGrid.noMachinesFound")}
                </Typography>
              </Box>
            ) : (
              <Box sx={{ height: 400 }}>
                <DataGrid
                  rows={machineRows}
                  columns={machineColumns}
                  loading={loadToMachinesLoading}
                  checkboxSelection
                  rowSelectionModel={selectedMachineIds}
                  onRowSelectionModelChange={(newSelection) => setSelectedMachineIds(newSelection)}
                  disableRowSelectionOnClick
                  initialState={{
                    pagination: {
                      paginationModel: { pageSize: 10 },
                    },
                  }}
                  pageSizeOptions={[10, 25, 50]}
                  sx={{
                    "& .MuiDataGrid-columnHeaderTitle": {
                      fontWeight: "bold",
                    },
                  }}
                />
              </Box>
            )}

            {selectedMachineIds.length > 0 && (
              <Typography variant="body2" color="primary">
                {t("stocks.slotGrid.selectedMachinesCount", { count: selectedMachineIds.length })}
              </Typography>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseLoadToMachinesDialog} disabled={loadToMachinesLoading}>
            {t("common.cancel")}
          </Button>
          <Button
            onClick={handleLoadToMachines}
            variant="contained"
            color="primary"
            disabled={loadToMachinesLoading || selectedMachineIds.length === 0}
            startIcon={loadToMachinesLoading ? <CircularProgress size={20} /> : <SendToMobileIcon />}
          >
            {t("stocks.slotGrid.loadButton")}
          </Button>
        </DialogActions>
      </Dialog>

      <SlotDragDropDialog
        open={dragDropDialogOpen}
        onClose={() => setDragDropDialogOpen(false)}
        selectedConfig={selectedConfig}
        existingSlots={rows}
        onSaved={handleDragDropSaved}
      />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}
